'use strict'

import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
import Vuelidate from 'vuelidate'

import '../node_modules/@fortawesome/fontawesome'
import '../node_modules/@fortawesome/fontawesome-free-solid'
import '../node_modules/@fortawesome/fontawesome-free-regular'
import '../node_modules/@fortawesome/fontawesome-free-brands'
import { svg } from '../src/components/elements/svg'
import { helpers } from '../src/helpers'
import { EventBus } from './helpers/event-bus'
import '../src/assets/main.scss'

const _config = require('./_config')

Vue.use(VueScrollTo)
Vue.use(Vuelidate)

Vue.prototype.$_config = _config
Vue.prototype.$axios = axios
Vue.prototype.$svg = svg
Vue.prototype.$helpers = helpers
Vue.prototype.$eventBus = EventBus

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js